import { uploadAttachments } from './uploadAttachments';

export const getUploaderButtons = ( setFiles, uploaderInstance, actionsState, modalStates, workspaceActions ) => [
  // {
  //   id: 'uploader-browse',
  //   cssClass: 'btn-uploader',
  //   iconCss: 'e-icons e-file-new',
  //   key: 'browse',
  //   onClick: () => {
  //     document
  //       .getElementsByClassName('e-file-select-wrap')[0]
  //       ?.querySelector('button')
  //       ?.click();
  //   },
  // },
  {
    id: 'uploader-clear-all',
    cssClass: 'btn-uploader',
    iconCss: 'e-icons e-trash',
    style: { marginLeft: '10px' },
    key: 'clear all',
    onClick: () => {
      setFiles([]);
      uploaderInstance.clearAll();
    },
  },
  {
    id: 'uploader-upload',
    cssClass: 'btn-uploader',
    style: { marginLeft: '10px' },
    iconCss: actionsState.attachments ? null: 'e-icons e-upload-1',
    key: 'upload',
    content: actionsState.attachments ? 'Ok': null ,
    onClick: () => {
      if (actionsState.attachments) {
        return uploadAttachments(
          actionsState.attachments,
          modalStates,
          workspaceActions
        );
      }
      uploaderInstance.upload();
    },
  },
];
